export { default } from './CustomerReviews';
export type { CustomerReviewsProps } from './CustomerReviews';
